import { SvgIcon } from '../SvgIcon';

const initialWidth = 60;
const initialHeight = 60;

export const UserGroupsIcon = ({
	className,
	height = initialHeight,
	width = initialWidth,
}: {
	className?: string;
	height?: number;
	width?: number;
}) => {
	return (
		<SvgIcon
			className={`plus-icon ${className || ''}`}
			height={height}
			width={width}
			viewBox={`0 0 ${initialWidth} ${initialHeight}`}
		>
			<g stroke='none' strokeWidth='1' fill='none' fillRule='evenodd'>
				<g>
					<circle fill='#0066FF' opacity='0.104043143' cx='30' cy='30' r='30' />
					<circle stroke='#0066FF' strokeWidth='2' fill='#FFFFFF' cx='30' cy='30' r='19' />
					<g id='Fill-1699-+-Fill-1700-+-Fill-1701-Copy' transform='translate(19, 20)' fill='#0066FF'>
						<path
							d='M17,13 C17.827,13 18.5,13.673 18.5,14.5 C18.5,15.327 17.827,16 17,16 C16.173,16 15.5,15.327 15.5,14.5 C15.5,13.673 16.173,13 17,13 M19.371,17.058 C20.061,16.418 20.5,15.513 20.5,14.5 C20.5,12.57 18.93,11 17,11 C15.07,11 13.5,12.57 13.5,14.5 C13.5,15.513 13.939,16.418 14.629,17.058 C13.151,17.593 12,18.62 12,20 L14,20 C14,19.402 15.413,18.643 17,18.643 C18.587,18.643 20,19.402 20,20 L22,20 C22,18.62 20.849,17.593 19.371,17.058'
							id='Fill-1699'
						/>
						<path
							d='M5,13 C5.827,13 6.5,13.673 6.5,14.5 C6.5,15.327 5.827,16 5,16 C4.173,16 3.5,15.327 3.5,14.5 C3.5,13.673 4.173,13 5,13 M7.371,17.058 C8.061,16.418 8.5,15.513 8.5,14.5 C8.5,12.57 6.93,11 5,11 C3.07,11 1.5,12.57 1.5,14.5 C1.5,15.513 1.939,16.418 2.629,17.058 C1.151,17.593 0,18.62 0,20 L2,20 C2,19.402 3.413,18.643 5,18.643 C6.587,18.643 8,19.402 8,20 L10,20 C10,18.62 8.849,17.593 7.371,17.058'
							id='Fill-1700'
						/>
						<path
							d='M11,2 C11.827,2 12.5,2.673 12.5,3.5 C12.5,4.327 11.827,5 11,5 C10.173,5 9.5,4.327 9.5,3.5 C9.5,2.673 10.173,2 11,2 M14,9 L16,9 C16,7.62 14.849,6.593 13.371,6.058 C14.061,5.418 14.5,4.513 14.5,3.5 C14.5,1.57 12.93,0 11,0 C9.07,0 7.5,1.57 7.5,3.5 C7.5,4.513 7.939,5.418 8.629,6.058 C7.151,6.593 6,7.62 6,9 L8,9 C8,8.402 9.413,7.643 11,7.643 C12.587,7.643 14,8.402 14,9'
							id='Fill-1701'
						/>
					</g>
				</g>
			</g>
		</SvgIcon>
	);
};
